module.exports = __webpack_public_path__ + "img/client-13.f44400b4.png";